export const TEAMS_PL = {
    
}